import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-148187e2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "process-page" }
const _hoisted_2 = { class: "page-header" }
const _hoisted_3 = { class: "nav-path" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nav-title" }, [
  /*#__PURE__*/_createElementVNode("span", null, "客户上报处理"),
  /*#__PURE__*/_createElementVNode("span", { class: "separator" }, "/"),
  /*#__PURE__*/_createElementVNode("span", null, "理赔验标上报"),
  /*#__PURE__*/_createElementVNode("span", { class: "separator" }, "/"),
  /*#__PURE__*/_createElementVNode("span", null, "详情")
], -1))
const _hoisted_5 = { class: "upper-section" }
const _hoisted_6 = { class: "content-wrapper" }
const _hoisted_7 = { class: "info-panel" }
const _hoisted_8 = { class: "info-content" }
const _hoisted_9 = { class: "info-item center-title" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"flex":"1","text-align":"center","padding-right":"24px"} }, "当前标的", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "alert-icon" }, "!", -1))
const _hoisted_12 = { class: "report-info" }
const _hoisted_13 = { class: "info-content" }
const _hoisted_14 = { class: "info-item" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "上报时间：", -1))
const _hoisted_16 = { class: "value" }
const _hoisted_17 = { class: "info-item" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "上报人员：", -1))
const _hoisted_19 = { class: "value" }
const _hoisted_20 = { class: "info-item info-note" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label orange-bar" }, "情况备注：", -1))
const _hoisted_22 = { class: "note-content" }
const _hoisted_23 = {
  key: 0,
  class: "info-item"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "语音记录：", -1))
const _hoisted_25 = { class: "media-list" }
const _hoisted_26 = { class: "audio-player" }
const _hoisted_27 = { class: "progress-container" }
const _hoisted_28 = { class: "progress-bar-wrapper" }
const _hoisted_29 = { class: "time-display" }
const _hoisted_30 = { key: 0 }
const _hoisted_31 = { key: 1 }
const _hoisted_32 = { class: "info-item" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label orange-bar" }, "联系电话：", -1))
const _hoisted_34 = { class: "value" }
const _hoisted_35 = { class: "info-item" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label orange-bar" }, "处理意见：", -1))
const _hoisted_37 = { class: "value" }
const _hoisted_38 = { class: "info-item" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label orange-bar" }, "客户结果反馈：", -1))
const _hoisted_40 = { class: "info-item" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "农户姓名：", -1))
const _hoisted_42 = { class: "value" }
const _hoisted_43 = { class: "info-item" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "案件号：", -1))
const _hoisted_45 = { class: "value" }
const _hoisted_46 = { class: "info-item" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "标的号：", -1))
const _hoisted_48 = { class: "value" }
const _hoisted_49 = { class: "info-item" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "登记号：", -1))
const _hoisted_51 = { class: "value" }
const _hoisted_52 = { class: "info-item" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "畜龄（月）：", -1))
const _hoisted_54 = { class: "value" }
const _hoisted_55 = { class: "info-item" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "采集位置：", -1))
const _hoisted_57 = { class: "value" }
const _hoisted_58 = { class: "info-item" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "GPS：", -1))
const _hoisted_60 = { class: "value" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_62 = { class: "info-item" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "采集日期：", -1))
const _hoisted_64 = { class: "value" }
const _hoisted_65 = { class: "info-item collect-info-item" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "采集信息：", -1))
const _hoisted_67 = { class: "value" }
const _hoisted_68 = { class: "collect-info-grid" }
const _hoisted_69 = { class: "compare-result" }
const _hoisted_70 = { class: "result-container" }
const _hoisted_71 = { class: "result-content" }
const _hoisted_72 = { class: "result-text" }
const _hoisted_73 = { class: "arrow-indicator" }
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "result-label" }, "投保对比结果：", -1))
const _hoisted_75 = { class: "arrow-indicator" }
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "result-label" }, "理赔对比结果：", -1))
const _hoisted_77 = { class: "image-panel" }
const _hoisted_78 = { class: "image-container" }
const _hoisted_79 = { class: "image-grid" }
const _hoisted_80 = ["onClick"]
const _hoisted_81 = { class: "pin-icon" }
const _hoisted_82 = {
  key: 0,
  class: "video-content",
  controls: "",
  style: {"width":"100%","height":"100%","object-fit":"contain"}
}
const _hoisted_83 = ["src"]
const _hoisted_84 = ["src", "alt"]
const _hoisted_85 = { class: "compare-toolbar" }
const _hoisted_86 = { class: "left-section" }
const _hoisted_87 = {
  key: 0,
  class: "cart-info"
}
const _hoisted_88 = { class: "compare-count" }
const _hoisted_89 = { class: "right-section" }
const _hoisted_90 = { class: "compare-items" }
const _hoisted_91 = ["onClick"]
const _hoisted_92 = {
  key: 0,
  class: "warning-message"
}
const _hoisted_93 = { class: "lower-section" }
const _hoisted_94 = { class: "content-wrapper" }
const _hoisted_95 = { class: "info-panel" }
const _hoisted_96 = { class: "info-content" }
const _hoisted_97 = { class: "info-item center-title" }
const _hoisted_98 = {
  key: 0,
  style: {"color":"red"}
}
const _hoisted_99 = { class: "info-item" }
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "农户姓名：", -1))
const _hoisted_101 = { class: "value" }
const _hoisted_102 = {
  key: 0,
  class: "info-item"
}
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "投保单号：", -1))
const _hoisted_104 = { class: "value" }
const _hoisted_105 = {
  key: 1,
  class: "info-item"
}
const _hoisted_106 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "案件号：", -1))
const _hoisted_107 = { class: "value" }
const _hoisted_108 = { class: "info-item" }
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "标的号：", -1))
const _hoisted_110 = { class: "value" }
const _hoisted_111 = { class: "info-item" }
const _hoisted_112 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "登记号：", -1))
const _hoisted_113 = { class: "value" }
const _hoisted_114 = { class: "info-item" }
const _hoisted_115 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "畜龄（月）：", -1))
const _hoisted_116 = { class: "value" }
const _hoisted_117 = { class: "info-item" }
const _hoisted_118 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "采集位置：", -1))
const _hoisted_119 = { class: "value" }
const _hoisted_120 = { class: "info-item" }
const _hoisted_121 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "GPS：", -1))
const _hoisted_122 = { class: "value" }
const _hoisted_123 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_124 = { class: "info-item" }
const _hoisted_125 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "采集日期：", -1))
const _hoisted_126 = { class: "value" }
const _hoisted_127 = { class: "info-item collect-info-item" }
const _hoisted_128 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "采集信息：", -1))
const _hoisted_129 = { class: "value" }
const _hoisted_130 = { class: "collect-info-grid" }
const _hoisted_131 = { class: "compare-result" }
const _hoisted_132 = {
  key: 0,
  class: "result-container"
}
const _hoisted_133 = { class: "result-content" }
const _hoisted_134 = { class: "image-panel" }
const _hoisted_135 = { class: "image-container" }
const _hoisted_136 = { class: "image-grid" }
const _hoisted_137 = ["onClick"]
const _hoisted_138 = { class: "pin-icon" }
const _hoisted_139 = {
  key: 0,
  class: "video-content",
  controls: "",
  style: {"width":"100%","height":"100%","object-fit":"contain"}
}
const _hoisted_140 = ["src"]
const _hoisted_141 = ["src", "alt"]

import { ref, computed, onMounted, nextTick, watch, onBeforeUnmount, onBeforeMount } from 'vue'
import { ArrowLeft, ArrowRight, CloseBold } from '@element-plus/icons-vue'
import incImgSvg from './incImgSvg.vue'
import { useRoute, useRouter } from 'vue-router'
import { getReportAndTargetDetail, reprocessReport, confirmExceptionReport } from '../../api'
import { ElMessage, ElMessageBox } from 'element-plus'
import RecompareDialog from './RecompareDialog.vue'
import ProcessResultDialog from './ProcessResultDialog.vue'
import BenzAMRRecorder from 'benz-amr-recorder'
import { ElLoading } from 'element-plus'
import { showWarningAlert } from '@/utiles/message';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProcessPage',
  setup(__props) {

const pageLoading = ref<any>(null)
const selectRef = ref(null)
const selectRef2 = ref(null)
const amrPlayer = ref<any>(null)
const currentTime = ref('00:00')
const playingIndex = ref<number | null>(null)
const isPaused = ref(false)
const currentProgress = ref(0)
const progressTimer = ref<any>(null)
const accumulatedTime = ref(0)
const resumeStartTime = ref<number>(0)
const router = useRouter()
const route = useRoute()
const compareResult = ref('')
const reportStatus = ref('')
const claimResult = ref('');
const popoverVisible = ref(false)
const processing = ref(false)
const activeType = ref('')
const currentIndex = ref(0)
const fixedStates = ref(new Map())
const currentCompareIndex = ref(0) // 当前选中的比较项索引
const onlyShowCompare = ref(false)
const compareStartIndex = ref(0)
const itemsPerPage = 10 // 每页显示的对比项数量
const fixedLimit = 3; // 固定图片的最大数量
const currentLowerIndex = ref(0)
const fixedStatesLower = ref(new Map())
const selectedCompareItems = ref({
    insurance: new Set<string>(),
    claim: new Set<string>()
});
const selectedTargets = ref({
    insurance: '', // 存储已确认的投保标的ID
    claim: ''      // 存储已确认的理赔标的ID
});
const recompareDialogVisible = ref(false)
const processResultVisible = ref(false)
const isTargetConfirmed = ref({
    insurance: false, // 投保确认状态
    claim: false,     // 理赔确认状态
});
// 控制当前激活的对比类型
const activeCompareType = ref('insurance'); // 默认选中投保对比结果

const switchCompareType = (type: string) => {
    activeCompareType.value = type;

    // 重置相关状态
    currentCompareIndex.value = 0;
    compareStartIndex.value = 0;

    // 自动选择第一个可用的采集信息类型
    if (simImages.value.length > 0) {
        const currentImage = simImages.value[0];
        if (currentImage?.picInfoVoList?.length > 0) {
            const typeOrder = ['FACE', 'LEFT_FACE', 'RIGHT_FACE', 'NOSE'];
            const firstAvailableType = typeOrder.find(type =>
                currentImage.picInfoVoList.some(info =>
                    info.picType === type && info.fileIds?.length > 0
                )
            );

            if (firstAvailableType) {
                activeTypeLower.value = firstAvailableType;
                switchTypeLower(activeTypeLower.value);
            }
        }
    }
};

const isReadonly = computed(() => route.query.readonly === 'true')
const isItemSelected = computed(() => {
    const currentItem = simImages.value[currentCompareIndex.value];
    return currentItem ? selectedCompareItems.value[activeCompareType.value].has(currentItem.id) : false;
});
// 下半部分的状态管理
const activeTypeLower = ref('front') // 默认显示正脸
const goBack = () => {
    router.back()
}
const collectTypes = [
    { label: '正脸', value: 'FACE' },
    { label: '左侧脸', value: 'LEFT_FACE' },
    { label: '右侧脸', value: 'RIGHT_FACE' },
    { label: '鼻纹', value: 'NOSE' },
    { label: '其他照片', value: 'OTHER' },
    { label: '视频', value: 'VIDEO' }
]
const availableTypes = computed(() => {
    const types = new Set();

    // 添加主要图片类型
    res.value?.targetInfo?.picInfoVoList?.forEach(item => {
        if (item.fileIds?.length > 0) {
            types.add(item.picType);
        }
    });

    // 添加其他照片类型
    if (res.value?.targetInfo?.otherFileInfoVoList?.some(item => item.fileType !== 1)) {
        types.add('OTHER');
    }

    // 添加视频类型
    if (res.value?.targetInfo?.otherFileInfoVoList?.some(item => item.fileType === 1)) {
        types.add('VIDEO');
    }

    // 返回过滤后的collectTypes
    return collectTypes.filter(type => types.has(type.value));
});
// 先定义一个固定的类型顺序常量
const TYPE_ORDER = ['FACE', 'LEFT_FACE', 'RIGHT_FACE', 'NOSE', 'OTHER', 'VIDEO'];

const getProcessedImages = computed(() => {
    const images = [];
    const tempImages = new Map(); // 用于临时存储各类型的图片

    // 初始化每种类型的数组
    TYPE_ORDER.forEach(type => {
        tempImages.set(type, []);
    });

    // 处理主要类型图片（正脸、左侧脸、右侧脸、鼻纹）
    res.value?.targetInfo?.picInfoVoList?.forEach(picInfo => {
        if (picInfo.fileIds) {
            picInfo.fileIds.forEach((file, index) => {
                const image = {
                    id: `${picInfo.picType}_${index}`,
                    url: file.cloudServiceType === '1' ?
                        res.value.ossUrl + file.url :
                        res.value.cosUrl + file.url,
                    type: picInfo.picType,
                    fixed: fixedStates.value.get(`${picInfo.picType}_${index}`) || false
                };

                // 将图片添加到对应类型的数组中
                if (tempImages.has(picInfo.picType)) {
                    tempImages.get(picInfo.picType).push(image);
                }
            });
        }
    });

    // 处理其他照片
    res.value?.targetInfo?.otherFileInfoVoList?.forEach((item, groupIndex) => {
        if (item.fileIds) {
            if (item.fileType !== 1) { // 非视频文件
                item.fileIds.forEach((file, fileIndex) => {
                    const image = {
                        id: `OTHER_${groupIndex}_${fileIndex}`,
                        url: file.cloudServiceType === '1' ?
                            res.value.ossUrl + file.url :
                            res.value.cosUrl + file.url,
                        type: 'OTHER',
                        fixed: fixedStates.value.get(`OTHER_${groupIndex}_${fileIndex}`) || false
                    };
                    tempImages.get('OTHER').push(image);
                });
            } else { // 视频文件
                item.fileIds.forEach((file, fileIndex) => {
                    const image = {
                        id: `VIDEO_${groupIndex}_${fileIndex}`,
                        url: file.cloudServiceType === '1' ?
                            res.value.ossUrl + file.url :
                            res.value.cosUrl + file.url,
                        type: 'VIDEO',
                        fixed: fixedStates.value.get(`VIDEO_${groupIndex}_${fileIndex}`) || false
                    };
                    tempImages.get('VIDEO').push(image);
                });
            }
        }
    });

    // 按照指定顺序合并所有图片
    TYPE_ORDER.forEach(type => {
        const typeImages = tempImages.get(type);
        if (typeImages && typeImages.length > 0) {
            images.push(...typeImages);
        }
    });

    return images;
});
const switchType = (type: string) => {
    activeType.value = type;
    const nonFixed = nonFixedImages.value;
    const fixedCount = fixedImages.value.length;

    // 找到第一张目标类型图片的索引
    const targetIndex = nonFixed.findIndex(img => img.type === type);

    if (targetIndex >= 0) {
        // 调整显示位置确保完整显示4张图片
        const maxIndex = Math.max(0, nonFixed.length - (4 - fixedCount));
        currentIndex.value = Math.min(targetIndex, maxIndex);
    } else {
        currentIndex.value = 0;
    }
};
const simImages = computed(() => {
    // 根据当前选择的对比类型决定使用哪个数据源
    const targetData = activeCompareType.value === 'insurance'
        ? [...(res.value?.simTarget || []), ...(res.value?.simTargetLow || [])]
        : [...(res.value?.payTarget || []), ...(res.value?.payTargetLow || [])];

    if (!targetData.length) return [];
  console.log('targetData', targetData);
  
    return targetData.map(target => ({
        id: target.id,
        delFlag: target.delFlag,
        targetNo: target.targetNo,
        sim: target.sim,
        farmerName: target.farmerName,
        orderNo: target.orderNo,
        caseNo: target.caseNo,
        earNo: target.earNo || target.collarBarcode,
        livestockAge: target.livestockAge,
        location: target.collectAddr,
        longitude: target.collectLocation?.split(',')[0] || '-',
        latitude: target.collectLocation?.split(',')[1] || '-',
        collectDate: target.created,
        picInfoVoList: target.picInfoVoList || [],
        otherFileInfoVoList: target.otherFileInfoVoList || [],
        claimFlag: target.claimFlag,
    }));
});
// 根据当前激活的对比类型返回对应的数量
const compareCount = computed(() => {
    return selectedCompareItems.value[activeCompareType.value].size;
});
const handleItemClick = (item, index) => {
    // 如果是只看对比项模式，需要找到真实的索引
    if (onlyShowCompare.value) {
        const realIndex = simImages.value.findIndex(i => i.id === item.id);
        currentCompareIndex.value = realIndex;
    } else {
        currentCompareIndex.value = compareStartIndex.value + index;
    }
};
// 显示序号
const getDisplayIndex = (item, index) => {
    if (onlyShowCompare.value) {
        // 在只看对比项模式下，找到项目在原数组中的位置
        return simImages.value.findIndex(i => i.id === item.id) + 1;
    } else {
        return compareStartIndex.value + index + 1;
    }
};
const recompareAvailableTypes = computed(() => {
    return availableTypes.value.filter(type =>
        !['OTHER', 'VIDEO'].includes(type.value)
    );
});
// 存储获取localStorage
const saveCompareItems = (targetId: string) => {
    localStorage.setItem(`compareItems:${targetId}`, JSON.stringify({
        insurance: Array.from(selectedCompareItems.value.insurance),
        claim: Array.from(selectedCompareItems.value.claim)
    }));
};
const handleClearAllCompare = () => {
    const currentType = activeCompareType.value; // 获取当前激活的类型
    const currentSet = selectedCompareItems.value[currentType]; // 获取当前类型的对比项集合

    if (currentSet.size === 0) {
        ElMessage.warning('当前没有对比项');
        return;
    }

    ElMessageBox.confirm(
        '确定要清除所有对比项吗？',
        '提示',
        {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }
    ).then(() => {
        // 只清除当前类型的对比项
        currentSet.clear();

        // 更新localStorage，但保留另一个类型的数据
        const targetId = route.query.id as string;
        const savedData = {
            insurance: Array.from(selectedCompareItems.value.insurance),
            claim: Array.from(selectedCompareItems.value.claim)
        };

        // 清除当前类型的数据
        savedData[currentType] = [];

        // 重新保存到localStorage
        localStorage.setItem(`compareItems:${targetId}`, JSON.stringify(savedData));

        // 如果当前是只看对比项模式就关闭
        if (onlyShowCompare.value) {
            onlyShowCompare.value = false;
        }

        // 重置当前索引到第一项
        currentCompareIndex.value = 0;
        compareStartIndex.value = 0;

        ElMessage.success('已清除所有对比项');
    }).catch(() => {
        // 用户取消操作，不做任何处理
    });
};
const getCompareItems = (targetId: string) => {
    const savedItems = localStorage.getItem(`compareItems:${targetId}`);
    if (savedItems) {
        const parsed = JSON.parse(savedItems);
        return {
            insurance: new Set(parsed.insurance || []),
            claim: new Set(parsed.claim || [])
        };
    }
    return {
        insurance: new Set<string>(),
        claim: new Set<string>()
    };
};
const handleCompareToggle = () => {
    const currentItem = simImages.value[currentCompareIndex.value];
    if (!currentItem) return;

    const targetId = route.query.id as string;
    const currentSet = selectedCompareItems.value[activeCompareType.value];

    if (currentSet.has(currentItem.id)) {
        // 取消对比
        currentSet.delete(currentItem.id);
        saveCompareItems(targetId);

        if (onlyShowCompare.value) {
            if (currentSet.size > 0) {
                const nextCompareItemIndex = simImages.value.findIndex(item =>
                    item.id !== currentItem.id && currentSet.has(item.id)
                );
                if (nextCompareItemIndex !== -1) {
                    currentCompareIndex.value = nextCompareItemIndex;
                }
            } else {
                onlyShowCompare.value = false;
                currentCompareIndex.value = simImages.value.findIndex(item =>
                    item.id === currentItem.id
                );
            }
        }
    } else {
        // 加入对比
        currentSet.add(currentItem.id);
        saveCompareItems(targetId);
    }
};
const getCompareItemClass = (item) => {
    const currentSet = selectedCompareItems.value[activeCompareType.value];
    return {
        'compare-item': true,
        'active': item.id === simImages.value[currentCompareIndex.value]?.id,
        'selected': currentSet.has(item.id)
    };
};
// 投保标的是否要禁用
const isInsuranceDisabled = computed(() => {
    const insuranceData = [
        ...(res.value?.simTarget || []),
        ...(res.value?.simTargetLow || [])
    ];
    return insuranceData.length === 0;
});
// 理赔标的是否要禁用
const isClaimDisabled = computed(() => {
    const claimData = [
        ...(res.value?.payTarget || []),
        ...(res.value?.payTargetLow || [])
    ];
    return claimData.length === 0;
});
const showWarningMessage = computed(() => {
    const targetInfo = res.value?.targetInfo;
    const isShow = targetInfo?.orderNo != null &&
        targetInfo?.verifyTargetOrCollarEnum !== 'NONE' &&
        targetInfo?.acceptTargetStatus === 'NORMAL';
    return isShow;
});
// 计算当前显示的对比项
const displayCompareItems = computed(() => {
    const currentSet = selectedCompareItems.value[activeCompareType.value];

    // 首先基于是否只看对比项进行过滤
    let filteredItems = onlyShowCompare.value
        ? simImages.value.filter(item => currentSet.has(item.id))
        : simImages.value;

    // 分页
    const start = compareStartIndex.value;
    const end = Math.min(start + itemsPerPage, filteredItems.length);
    return filteredItems.slice(start, end);
});
// 计算是否可以前后翻页
const canGoPreviousCompare = computed(() => {
    return compareStartIndex.value > 0
})
const canGoNextCompare = computed(() => {
    const currentSet = selectedCompareItems.value[activeCompareType.value];
    const totalItems = onlyShowCompare.value
        ? currentSet.size
        : simImages.value.length;
    return compareStartIndex.value + itemsPerPage < totalItems;
});
// 翻页
const previousCompareItems = () => {
    if (canGoPreviousCompare.value) {
        compareStartIndex.value = Math.max(0, compareStartIndex.value - itemsPerPage);
    }
};
const nextCompareItems = () => {
    if (canGoNextCompare.value) {
        const currentSet = selectedCompareItems.value[activeCompareType.value];
        const totalItems = onlyShowCompare.value
            ? currentSet.size
            : simImages.value.length;
        compareStartIndex.value = Math.min(
            totalItems - itemsPerPage,
            compareStartIndex.value + itemsPerPage
        );
    }
};
const targetIds = computed(() => ({
    currentId: res.value?.targetInfo?.id || '',
    compareId: simImages.value[currentCompareIndex.value]?.id || ''
}));
// 计算按钮状态的计算属性
const canGoNext = computed(() => {
    const nonFixed = nonFixedImages.value;
    const fixedCount = fixedImages.value.length;
    const remainingCount = 4 - fixedCount;

    // 确保下一页有完整的图片可以显示
    return currentIndex.value < Math.max(0, nonFixed.length - remainingCount);
});

const canGoPrevious = computed(() => {
    return currentIndex.value > 0;
});
// 翻页
const nextImage = () => {
    if (canGoNext.value) {
        const nonFixed = nonFixedImages.value;
        const fixedCount = fixedImages.value.length;
        const remainingCount = 4 - fixedCount;

        // 计算下一页的索引，确保显示完整的图片
        const nextIndex = Math.min(
            currentIndex.value + 1,
            Math.max(0, nonFixed.length - remainingCount)
        );
        currentIndex.value = nextIndex;
    }
};

const previousImage = () => {
    if (canGoPrevious.value) {
        currentIndex.value = Math.max(0, currentIndex.value - 1);
    }
};
const handleComplete = () => {
    if (!compareResult.value || !claimResult.value) {
        // ElMessage.warning('请选择投保对比结果和理赔对比结果');
        showWarningAlert('请选择投保对比结果和理赔对比结果')
        return;
    }
    // 检查都设置为 REPEAT 时的情况
    if (compareResult.value === 'REPEAT' && claimResult.value === 'REPEAT') {
        if (!isTargetConfirmed.value.insurance && !isTargetConfirmed.value.claim) {
            // ElMessage.warning('请在投保对比结果和理赔对比结果中确认标的');
            showWarningAlert('请在投保对比结果和理赔对比结果中确认标的')
            return;
        }
        if (!isTargetConfirmed.value.insurance) {
            // ElMessage.warning('当前投保对比结果选择为投保标的，请选择对应的标的');
            showWarningAlert('当前投保对比结果选择为投保标的，请选择对应的标的')
            return;
        }
        if (!isTargetConfirmed.value.claim) {
            // ElMessage.warning('当前理赔对比结果选择为重复标的，请选择对应的标的');
            showWarningAlert('当前理赔对比结果选择为重复标的，请选择对应的标的')
            return;
        }
    }
    // 只有投保结果为 REPEAT 的情况
    else if (compareResult.value === 'REPEAT' && !isTargetConfirmed.value.insurance) {
        // ElMessage.warning('当前投保对比结果选择为投保标的，请选择对应的标的');
        showWarningAlert('当前投保对比结果选择为投保标的，请选择对应的标的')
        return;
    }
    // 只有理赔结果为 REPEAT 的情况
    else if (claimResult.value === 'REPEAT' && !isTargetConfirmed.value.claim) {
        // ElMessage.warning('当前理赔对比结果选择为重复标的，请选择对应的标的');
        showWarningAlert('当前理赔对比结果选择为重复标的，请选择对应的标的')
        return;
    }

    // 直接从原始数据源获取确认的标的信息
    const confirmedInsuranceTarget = [
        ...(res.value?.simTarget || []),
        ...(res.value?.simTargetLow || [])
    ].find(item => item.id === selectedTargets.value.insurance);

    const confirmedClaimTarget = [
        ...(res.value?.payTarget || []),
        ...(res.value?.payTargetLow || [])
    ].find(item => item.id === selectedTargets.value.claim);

    processResultVisible.value = true;

    const processResultProps = {
        reportInfo: {
            reportTime: detail.value.reportTime,
            creator: detail.value.creator,
            orderNo: targetInfo.value.orderNo,
            targetNo: targetInfo.value.targetNo,
            earNo: targetInfo.value.earNo || targetInfo.value.collarBarcode,
            note: detail.value.note,
            voiceFiles: detail.value.voiceFiles,
            phone: detail.value.phone,
            caseNo: targetInfo.value.caseNo,
            cosUrl: detail.value.cosUrl
        },
        processResult: {
            // 投保对比结果
            compareResult: compareResult.value === 'REPEAT' ? '投保标的' : '非投保标的',
            // 理赔对比结果
            claimResult: claimResult.value === 'REPEAT' ? '重复理赔标的' : '唯一理赔标的',
            duplicateInfo: {
                // 投保标的信息
                id: confirmedInsuranceTarget?.id || '',
                orderNo: confirmedInsuranceTarget?.orderNo || '',
                targetNo: confirmedInsuranceTarget?.targetNo || '',
                earNo: confirmedInsuranceTarget?.earNo || confirmedInsuranceTarget?.collarBarcode || '',
                similarity: confirmedInsuranceTarget ? `${Math.floor((confirmedInsuranceTarget.sim || 0) * 100)}%` : '',

                // 理赔标的信息
                claimId: confirmedClaimTarget?.id || '',
                caseNo: confirmedClaimTarget?.caseNo || '',
                claimTargetNo: confirmedClaimTarget?.targetNo || '',
                claimEarNo: confirmedClaimTarget?.earNo || confirmedClaimTarget?.collarBarcode || '',
                claimSimilarity: confirmedClaimTarget ? `${Math.floor((confirmedClaimTarget.sim || 0) * 100)}%` : ''
            },
            description: ''
        }
    };

    Object.assign(processResultDialogProps.value, processResultProps);
};
// 存储dialog props
const processResultDialogProps = ref({
    reportInfo: {
        reportTime: '',
        creator: '',
        orderNo: '',
        targetNo: '',
        earNo: '',
        note: '',
        voiceFiles: [],
        phone: ''
    },
    processResult: {
        compareResult: '',
        claimResult: '',
        duplicateInfo: {},
        description: ''
    }
});
const handleReprocess = () => {
    const exceptionReportId = route.query.id as string;

    ElMessageBox.confirm(
        '请确认是否重新处理当前投保采集上报任务？',
        '警告提醒',
        {
            confirmButtonText: '确定重新处理',
            cancelButtonText: '取消',
            type: 'warning'
        }
    ).then(async () => {
        try {
            await reprocessReport(exceptionReportId, { noErrorMsg: true })
            ElMessage.success('重新处理成功');
            const query = { ...route.query };
            delete query.readonly;  // 删除readonly参数
            router.replace({
                path: route.path,
                query: query
            }).then(() => {
                window.location.reload(); // 刷新页面
            });
        } catch (error: any) {
            await ElMessageBox.alert(
                error[0]?.message || '失败',
                '错误',
                {
                    confirmButtonText: '我知道了',
                    type: 'error',
                }
            )
        }
    }).catch(() => {
        // 用户取消操作，不做任何处理
    });
};
const handleProcessConfirm = async (result) => {
    try {
        // 获取当前exceptionReportId
        const exceptionReportId = route.query.id as string;

        // 构建请求参数对象
        const requestData: any = {
            exceptionReportId: exceptionReportId,
            handleResult: result.description, // 处理结果说明
        }

        // 只有当投保对比结果为"投保标的"时，才添加相关参数
        if (compareResult.value === 'REPEAT') {
            requestData.acceptResult = 'REPEAT'
            // 只有在确认了标的时才添加acceptSimilarId
            if (selectedTargets.value.insurance) {
                requestData.acceptSimilarId = selectedTargets.value.insurance
            }
        } else if (compareResult.value === 'NORMAL') {
            requestData.acceptResult = 'NORMAL'
        }

        // 只有当理赔对比结果为"重复理赔标的"时，才添加相关参数
        if (claimResult.value === 'REPEAT') {
            requestData.paymentResult = 'REPEAT'
            // 只有在确认了标的时才添加paymentSimilarId
            if (selectedTargets.value.claim) {
                requestData.paymentSimilarId = selectedTargets.value.claim
            }
        } else if (claimResult.value === 'NORMAL') {
            requestData.paymentResult = 'NORMAL'
        }

        // 调用接口
        await confirmExceptionReport(requestData, { noErrorMsg: true })

        // 删除localStorage中的对应项
        const targetId = route.query.id as string;
        localStorage.removeItem(`compareItems:${targetId}`);

        ElMessage.success('处理成功')
        processResultVisible.value = false
        router.back()
    } catch (error: any) {
        await ElMessageBox.alert(
            error[0]?.message || '失败',
            '错误',
            {
                confirmButtonText: '我知道了',
                type: 'error',
            }
        )
    }
}
const handleConfirmTarget = () => {
    const currentType = activeCompareType.value;
    const currentItem = simImages.value[currentCompareIndex.value];

    // 如果当前项就是已确认的项
    if (selectedTargets.value[currentType] === currentItem.id) {
        // 取消确认的逻辑
        ElMessageBox.confirm(
            '是否取消确认该标的？',
            '提示',
            {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }
        )
            .then(() => {
                selectedTargets.value[currentType] = ''; // 清除已选ID
                isTargetConfirmed.value[currentType] = false;
                ElMessage({
                    type: 'success',
                    message: '已取消确认'
                });
            })
            .catch(() => { });
    } else {
        // 确认新标的的逻辑
        let message = '确认选择该标的作为对比标的？';
        if (selectedTargets.value[currentType]) {
            message = '已有确认的标的，是否改为确认当前标的？';
        }

        ElMessageBox.confirm(
            message,
            '提示',
            {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }
        )
            .then(() => {
                selectedTargets.value[currentType] = currentItem.id; // 更新已选ID
                isTargetConfirmed.value[currentType] = true;
                ElMessage({
                    type: 'success',
                    message: '已确认标的'
                });
            })
            .catch(() => { });
    }
};
// 判断当前项是否是已确认的标的
const isCurrentItemConfirmed = computed(() => {
    const currentItem = simImages.value[currentCompareIndex.value];
    return currentItem  && selectedTargets.value[activeCompareType.value] === currentItem.id;
});
// 获取确认按钮的文本
const getConfirmButtonText = computed(() => {
    return isCurrentItemConfirmed.value ? '已确认标的' : '确认标的';
});

const getConfirmButtonStatus = computed(() => {
    
    
    const currentItem = simImages.value[currentCompareIndex.value];
    console.log('currentItem.delFlag',currentItem,reportStatus.value === '2');
    return (currentItem == null || (currentItem && currentItem.delFlag === 'N')) && reportStatus.value === '2';
});
//已理赔状态
const getClaimFlag = computed(() => {
  const currentItem = simImages.value[currentCompareIndex.value];
  return currentItem && (currentItem.claimFlag === 'Y');
});
// 计算固定的图片，不再过滤类型
const fixedImages = computed(() => {
    // 获取所有固定的图片，不再根据 activeType 过滤
    const fixedImagesMap = new Map();
    getProcessedImages.value.forEach(image => {
        if (image.fixed) {
            // 使用 fixedStates 中的设置时间作为排序依据
            const fixedTime = fixedStates.value.get(image.id);
            if (fixedTime) {
                fixedImagesMap.set(image.id, {
                    ...image,
                    fixedTime
                });
            }
        }
    });

    // 按照固定时间排序并返回结果
    return Array.from(fixedImagesMap.values())
        .sort((a, b) => a.fixedTime - b.fixedTime)
        .slice(0, fixedLimit);
});
// 计算未固定的图片，同样只包含当前选中类型的图片
const nonFixedImages = computed(() => {
    // 直接返回未固定的图片，保持原始顺序
    return getProcessedImages.value.filter(image => !image.fixed);
});
// 显示图片的计算
const displayImages = computed(() => {
    const fixed = fixedImages.value;
    const fixedCount = fixed.length;
    const nonFixed = nonFixedImages.value;

    // 计算需要显示的非固定图片数量
    const remainingCount = 4 - fixedCount;

    // 调整 currentIndex 以确保始终显示4张图片（如果有足够的图片）
    if (currentIndex.value > Math.max(0, nonFixed.length - remainingCount)) {
        currentIndex.value = Math.max(0, nonFixed.length - remainingCount);
    }

    // 获取要显示的非固定图片
    const displayNonFixed = nonFixed.slice(
        currentIndex.value,
        currentIndex.value + remainingCount
    );

    return [...fixed, ...displayNonFixed];
});
const toggleFix = (image) => {
    const currentFixed = fixedStates.value.get(image.id);

    if (currentFixed) {
        fixedStates.value.delete(image.id);
    } else {
        const fixedCount = Array.from(fixedStates.value.values()).filter(x => x).length;
        if (fixedCount < fixedLimit) {
            // 使用时间戳记录固定顺序
            fixedStates.value.set(image.id, Date.now());
        } else {
            ElMessage.warning(`最多只能固定${fixedLimit}张图片`);
        }
    }
};
const targetInfo = ref({
    farmerName: '',  // 农户姓名
    caseNo: '',   // 案件号
    targetNo: '',    // 标的号
    earNo: '',       // 耳标号
    collarBarcode: '', // 项圈号
    collectAddr: '', // 采集位置
    collectLocation: '', // GPS
    created: '',      // 采集日期
    livestockAge: '', // 畜龄（月）
})
const res = ref(null);
const detail = ref(null);
const appTargetDetailFn = async (id: string) => {
    pageLoading.value = ElLoading.service({
        lock: true,
        text: '数据加载中...',
        background: 'rgba(0, 0, 0, 0.7)'
    })
    try {
        const targetId = route.query.targetId as string;
        const response = await getReportAndTargetDetail(id, targetId);

        if (response) {
            res.value = response.appTargetDetailVo;

            detail.value = {
                reportTime: response.reportVo.reportTime,
                creator: response.reportVo.creator,
                note: response.reportVo.remark,
                phone: response.reportVo.phone,
                voiceFiles: response.reportVo.voiceFiles,
                targetNo: response.reportVo.targetNo,
                orderNo: response.reportVo.orderNo,
                cosUrl: response.reportVo.cosUrl,
                caseId: response.reportVo.caseId,
                orderId: response.reportVo.orderId,
                handleResult: response.reportVo.handleResult,
                handleResultFeedback: response.reportVo.handleResultFeedback
            };

            reportStatus.value = response.reportVo.status

            if (response.appTargetDetailVo.targetInfo) {
                // 设置投保对比结果：优先使用 acceptResult，如果没有则使用 acceptTargetStatus
                compareResult.value = response.reportVo.acceptResult ||
                    (response.appTargetDetailVo.targetInfo.acceptTargetStatus === 'REPEAT' ? 'REPEAT' : 'NORMAL') || ''

                // 设置理赔对比结果：优先使用 paymentResult，如果没有则使用 targetStatus
                claimResult.value = response.reportVo.paymentResult ||
                    (response.appTargetDetailVo.targetInfo.targetStatus === 'REPEAT' ? 'REPEAT' : 'NORMAL') || ''

                // 如果有已确认的标的,也需要设置
                if (response.appTargetDetailVo.targetInfo.acceptSimilarId) {
                    selectedTargets.value.insurance = response.appTargetDetailVo.targetInfo.acceptSimilarId
                    isTargetConfirmed.value.insurance = true
                }

                if (response.appTargetDetailVo.targetInfo.paymentSimilarId) {
                    selectedTargets.value.claim = response.appTargetDetailVo.targetInfo.paymentSimilarId
                    isTargetConfirmed.value.claim = true
                }
            }

            targetInfo.value = {
                farmerName: response.appTargetDetailVo.targetInfo?.farmerName || '-',
                caseNo: response.appTargetDetailVo.targetInfo?.caseNo || '-',
                targetNo: response.appTargetDetailVo.targetInfo?.targetNo || '-',
                earNo: response.appTargetDetailVo.targetInfo?.earNo || null,
                collarBarcode: response.appTargetDetailVo.targetInfo?.collarBarcode || '-',
                collectAddr: response.appTargetDetailVo.targetInfo?.collectAddr || '-',
                collectLocation: response.appTargetDetailVo.targetInfo?.collectLocation || '',
                created: response.appTargetDetailVo.targetInfo?.created || '-',
                livestockAge: response.appTargetDetailVo.livestockAge || '-'
            }
        }
    } catch (error) {
        console.error('获取数据失败:', error);
    } finally {
        // 无论成功还是失败都关闭loading
        pageLoading.value?.close()
    }
};

const playAudio = async (url: string, index: number) => {
    try {
        // 如果点击的是当前音频
        if (playingIndex.value === index) {
            if (amrPlayer.value.isPlaying()) {
                // -暂停播放
                amrPlayer.value.pause()
                isPaused.value = true

                // 停止进度更新，并记录当前已播放时间
                clearInterval(progressTimer.value)
                // 这里算一下当前段播放了多久（秒）
                const played = (Date.now() - resumeStartTime.value) / 1000
                accumulatedTime.value += played

            } else if (isPaused.value) {
                // -- 继续播放 --
                amrPlayer.value.resume()
                isPaused.value = false

                // 重新设置一个起始时间戳
                resumeStartTime.value = Date.now()

                startProgressTracking(index)
            } else {
                // -- 停止播放 --
                stopPlayer()
            }
            return
        }

        // 如果有其他音频在播放，先停止并重置
        if (playingIndex.value !== null && playingIndex.value !== index) {
            stopPlayer()
            // 加了一个小延迟确保前一个音频的 stop() 绝对生效
            await new Promise(resolve => setTimeout(resolve, 50))
        }

        // -- 播放新的音频 --
        playingIndex.value = index
        currentProgress.value = 0
        accumulatedTime.value = 0   // 新音频时，累计播放时长清0
        isPaused.value = false

        await amrPlayer.value.initWithUrl(url)

        // 监听播放结束
        amrPlayer.value.onEnded(() => {
            stopPlayer()
        })

        await amrPlayer.value.play()

        // 记录“本次开始”的时间戳
        resumeStartTime.value = Date.now()

        startProgressTracking(index)
    } catch (error) {
        console.error('音频播放失败:', error)
        ElMessage.error('音频播放失败')
        stopPlayer()
    }
}

// 进度跟踪
const startProgressTracking = (index: number) => {
    clearInterval(progressTimer.value)

    const duration = detail.value.voiceFiles[index].shotTime // 音频时长（秒）

    progressTimer.value = setInterval(() => {
        if (!isPaused.value) {
            // 当前已播放秒数 = 累计已播放 + 当前区间（从resumeStartTime开始算起）
            const elapsed = accumulatedTime.value + (Date.now() - resumeStartTime.value) / 1000

            currentProgress.value = Math.min((elapsed / duration) * 100, 100)
            // 更新当前时间显示
            const currentSeconds = Math.floor(elapsed)
            const clampedSeconds = Math.min(currentSeconds, duration)

            currentTime.value = formatTime(clampedSeconds) + ' / ' + formatTime(duration)

            // 如果播放到头了
            if (currentProgress.value >= 100) {
                clearInterval(progressTimer.value)
            }
        }
    }, 100)
};

// 停止播放/重置状态
const stopPlayer = () => {
    amrPlayer.value.stop()
    amrPlayer.value = new BenzAMRRecorder()

    clearInterval(progressTimer.value)
    playingIndex.value = null
    isPaused.value = false
    currentProgress.value = 0
    currentTime.value = '00:00'
    accumulatedTime.value = 0
    resumeStartTime.value = 0
}

const formatTime = (seconds: number) => {
    const minutes = Math.floor(seconds / 60)
    const remainingSeconds = Math.floor(seconds % 60)
    return `${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`
}

const handleScroll = () => {
    // 确保 select 存在
    if (selectRef.value) {
        selectRef.value.blur(); // 让 select 失去焦点
        selectRef.value.handleClose(); // 关闭下拉菜单
    }
};
const handleScroll2 = () => {
    // 确保 select 存在
    if (selectRef2.value) {
        selectRef2.value.blur(); // 让 select 失去焦点
        selectRef2.value.handleClose(); // 关闭下拉菜单
    }
};

onBeforeMount(() => {
    amrPlayer.value = new BenzAMRRecorder()
});
onBeforeUnmount(() => {
    const targetId = route.query.id as string;
    saveCompareItems(targetId, selectedCompareItems.value);


    if (amrPlayer.value) {
        amrPlayer.value.stop()
    }
    clearInterval(progressTimer.value)
    pageLoading.value?.close()

    document.removeEventListener('scroll', handleScroll, true);
    document.removeEventListener('scroll', handleScroll2, true);
});
onMounted(() => {
    const targetId = route.query.id as string
    appTargetDetailFn(targetId)

    // 从localStorage恢复对比项
    const savedItems = getCompareItems(targetId);
    selectedCompareItems.value = savedItems;

    // 监听容器的滚动
    document.addEventListener('scroll', handleScroll, true);
    document.addEventListener('scroll', handleScroll2, true);
})

// 计算属性来获取可用的类型
const availableTypesLower = computed(() => {
    const currentImage = simImages.value[currentCompareIndex.value];
    if (!currentImage?.picInfoVoList) return [];

    const types = new Set();

    // 按照指定顺序检查和添加可用类型
    TYPE_ORDER.forEach(type => {
        // 检查主要类型
        const hasPicType = currentImage.picInfoVoList.some(
            info => info.picType === type && info.fileIds?.length > 0
        );
        if (hasPicType) {
            types.add(type);
        }

        // 检查其他照片和视频
        if (type === 'OTHER' || type === 'VIDEO') {
            const hasOtherOrVideo = currentImage.otherFileInfoVoList?.some(info =>
                info.fileIds?.length > 0 &&
                ((type === 'OTHER' && info.fileType !== 1) ||
                    (type === 'VIDEO' && info.fileType === 1))
            );
            if (hasOtherOrVideo) {
                types.add(type);
            }
        }
    });

    return collectTypes.filter(type => types.has(type.value));
});
const getProcessedLowerImages = (currentImage) => {
    if (!currentImage) return [];
    const images = [];

    // 按照指定顺序处理图片
    TYPE_ORDER.forEach(type => {
        // 找到对应类型的图片组
        const picInfo = currentImage.picInfoVoList?.find(info => info.picType === type);
        if (picInfo?.fileIds) {
            picInfo.fileIds.forEach((fileId, fileIndex) => {
                images.push({
                    id: `${currentCompareIndex.value}_${type}_${fileIndex}`,
                    url: fileId.cloudServiceType === '1' ?
                        res.value.ossUrl + fileId.url :
                        res.value.cosUrl + fileId.url,
                    type: type,
                    fixed: fixedStatesLower.value.get(`${currentCompareIndex.value}_${type}_${fileIndex}`) || false
                });
            });
        }

        // 处理其他照片和视频
        if (type === 'OTHER' || type === 'VIDEO') {
            currentImage.otherFileInfoVoList?.forEach((info, groupIndex) => {
                if (info.fileIds &&
                    ((type === 'OTHER' && info.fileType !== 1) ||
                        (type === 'VIDEO' && info.fileType === 1))) {
                    info.fileIds.forEach((fileId, fileIndex) => {
                        images.push({
                            id: `${currentCompareIndex.value}_${type}_${groupIndex}_${fileIndex}`,
                            url: fileId.cloudServiceType === '1' ?
                                res.value.ossUrl + fileId.url :
                                res.value.cosUrl + fileId.url,
                            type: type,
                            fixed: fixedStatesLower.value.get(`${currentCompareIndex.value}_${type}_${groupIndex}_${fileIndex}`) || false
                        });
                    });
                }
            });
        }
    });

    return images;
};
const displayImagesLower = computed(() => {
    const fixed = fixedImagesLower.value;
    const fixedCount = fixed.length;
    const nonFixed = nonFixedImagesLower.value;

    // 计算需要显示的非固定图片数量
    const remainingCount = 4 - fixedCount;

    // 调整索引以确保始终显示4张图片
    if (currentLowerIndex.value > Math.max(0, nonFixed.length - remainingCount)) {
        currentLowerIndex.value = Math.max(0, nonFixed.length - remainingCount);
    }

    // 获取要显示的非固定图片
    const displayNonFixed = nonFixed.slice(
        currentLowerIndex.value,
        currentLowerIndex.value + remainingCount
    );

    return [...fixed, ...displayNonFixed];
});
const fixedImagesLower = computed(() => {
    const fixedImagesMap = new Map();
    const allImages = getProcessedLowerImages(simImages.value[currentCompareIndex.value]);

    allImages.forEach(image => {
        if (fixedStatesLower.value.get(image.id)) {
            // 使用固定的时间戳作为排序依据
            const fixedTime = fixedStatesLower.value.get(image.id);
            fixedImagesMap.set(image.id, {
                ...image,
                fixedTime
            });
        }
    });

    // 按照固定时间排序
    return Array.from(fixedImagesMap.values())
        .sort((a, b) => a.fixedTime - b.fixedTime)
        .slice(0, 3); // 限制最多3张固定图片
});
const nonFixedImagesLower = computed(() => {
    const currentItem = simImages.value[currentCompareIndex.value];
    if (!currentItem) return [];

    // 获取所有图片并保持原始顺序
    const allImages = getProcessedLowerImages(currentItem);
    return allImages.filter(img => !fixedStatesLower.value.get(img.id));
});
const toggleFixLower = (image) => {
    const currentFixed = fixedStatesLower.value.get(image.id);

    if (currentFixed) {
        fixedStatesLower.value.delete(image.id);
    } else {
        const fixedCount = Array.from(fixedStatesLower.value.values()).filter(x => x).length;
        if (fixedCount < 3) {
            // 使用时间戳记录固定顺序
            fixedStatesLower.value.set(image.id, Date.now());
        } else {
            ElMessage.warning('最多只能固定3张图片');
        }
    }
};
const canGoNextLower = computed(() => {
    const nonFixed = nonFixedImagesLower.value;
    const fixedCount = fixedImagesLower.value.length;
    const remainingCount = 4 - fixedCount;

    // 确保下一页有完整的图片可以显示
    return currentLowerIndex.value < Math.max(0, nonFixed.length - remainingCount);
});

const canGoPreviousLower = computed(() => {
    return currentLowerIndex.value > 0;
});
// 图片切换
const nextImageLower = () => {
    if (canGoNextLower.value) {
        const nonFixed = nonFixedImagesLower.value;
        const fixedCount = fixedImagesLower.value.length;
        const remainingCount = 4 - fixedCount;

        // 计算下一页的索引，确保显示完整的图片
        const nextIndex = Math.min(
            currentLowerIndex.value + 1,
            Math.max(0, nonFixed.length - remainingCount)
        );
        currentLowerIndex.value = nextIndex;
    }
};

const previousImageLower = () => {
    if (canGoPreviousLower.value) {
        currentLowerIndex.value = Math.max(0, currentLowerIndex.value - 1);
    }
};
const switchTypeLower = (type: string) => {
    activeTypeLower.value = type;
    const nonFixed = nonFixedImagesLower.value;
    const fixedCount = fixedImagesLower.value.length;

    // 找到第一张目标类型图片的索引
    const targetIndex = nonFixed.findIndex(img => img.type === type);

    if (targetIndex >= 0) {
        // 调整显示位置确保完整显示4张图片
        const maxIndex = Math.max(0, nonFixed.length - (4 - fixedCount));
        currentLowerIndex.value = Math.min(targetIndex, maxIndex);
    } else {
        currentLowerIndex.value = 0;
    }
};
watch(currentCompareIndex, () => {
    fixedStatesLower.value.clear();
    currentLowerIndex.value = 0;
});
const handleRecompare = () => {
    recompareDialogVisible.value = true
};
// 监听对比类型变化
watch(activeCompareType, () => {
    // 重置到第一项
    currentCompareIndex.value = 0;
    // 同时重置分页起始位置
    compareStartIndex.value = 0;
});
watch(onlyShowCompare, (newVal) => {
    const currentSet = selectedCompareItems.value[activeCompareType.value];
    if (newVal && currentSet.size === 0) {
        ElMessage.warning('请先选择需要对比的项目');
        onlyShowCompare.value = false;
        return;
    }

    compareStartIndex.value = 0;

    if (newVal) {
        const currentItem = simImages.value[currentCompareIndex.value];
        if (currentItem && !currentSet.has(currentItem.id)) {
            const firstCompareItemIndex = simImages.value.findIndex(item =>
                currentSet.has(item.id)
            );
            if (firstCompareItemIndex !== -1) {
                currentCompareIndex.value = firstCompareItemIndex;
            }
        }
    }
});
watch(compareResult, (newValue) => {
    if (newValue === 'NORMAL') { // 当切换到"非投保标的"时
        selectedTargets.value.insurance = ''; // 清除已选择的投保标的ID
        isTargetConfirmed.value.insurance = false; // 重置确认状态
        selectedCompareItems.value.insurance.clear()
    }
});
watch(claimResult, (newValue) => {
    if (newValue === 'NORMAL') { // 当切换到"唯一理赔标的"时
        selectedTargets.value.claim = ''; // 清除已选择的理赔标的ID
        isTargetConfirmed.value.claim = false; // 重置确认状态
        selectedCompareItems.value.claim.clear()
    }
});

watch(popoverVisible, (newVisible) => {
    if (!newVisible && playingIndex.value !== null) {
        stopPlayer()
    }
});

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_Close = _resolveComponent("Close")!
  const _component_el_progress = _resolveComponent("el-progress")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_button, {
            link: "",
            onClick: goBack,
            class: "back-button"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_unref(ArrowLeft))
                ]),
                _: 1
              }),
              _createTextVNode(" 返回 ")
            ]),
            _: 1
          }),
          _hoisted_4
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createVNode(_component_el_popover, {
                  visible: popoverVisible.value,
                  "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((popoverVisible).value = $event)),
                  placement: "bottom",
                  width: 300,
                  trigger: "click"
                }, {
                  reference: _withCtx(() => [
                    _hoisted_11
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_12, [
                      _createVNode(_component_el_button, {
                        class: "close-btn",
                        type: "text",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (popoverVisible.value = false))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_Close)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                          _hoisted_15,
                          _createElementVNode("span", _hoisted_16, _toDisplayString(detail.value?.reportTime), 1)
                        ]),
                        _createElementVNode("div", _hoisted_17, [
                          _hoisted_18,
                          _createElementVNode("span", _hoisted_19, _toDisplayString(detail.value?.creator), 1)
                        ]),
                        _createElementVNode("div", _hoisted_20, [
                          _hoisted_21,
                          _createElementVNode("div", _hoisted_22, _toDisplayString(detail.value?.note ? detail.value.note : '-无情况备注内容-'), 1)
                        ]),
                        (detail.value?.voiceFiles?.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                              _hoisted_24,
                              _createElementVNode("div", _hoisted_25, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detail.value.voiceFiles, (media, index) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: index,
                                    class: "media-item"
                                  }, [
                                    _createElementVNode("div", _hoisted_26, [
                                      _createVNode(_component_el_button, {
                                        type: "primary",
                                        link: "",
                                        size: "small",
                                        onClick: ($event: any) => (playAudio(detail.value.cosUrl + media.url, index))
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_icon, null, {
                                            default: _withCtx(() => [
                                              (_openBlock(), _createBlock(_resolveDynamicComponent(playingIndex.value === index ?
                                                                    (isPaused.value ? 'VideoPlay' : 'VideoPause') :
                                                                    'VideoPlay')))
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"]),
                                      _createElementVNode("div", _hoisted_27, [
                                        _createElementVNode("div", _hoisted_28, [
                                          _createVNode(_component_el_progress, {
                                            percentage: playingIndex.value === index ? currentProgress.value : 0,
                                            "show-text": false,
                                            "stroke-width": 4,
                                            status: "success"
                                          }, null, 8, ["percentage"])
                                        ]),
                                        _createElementVNode("div", _hoisted_29, [
                                          (playingIndex.value === index)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(currentTime.value), 1))
                                            : (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString('00:00 / ' + formatTime(media.shotTime)), 1))
                                        ])
                                      ])
                                    ])
                                  ]))
                                }), 128))
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_32, [
                          _hoisted_33,
                          _createElementVNode("span", _hoisted_34, _toDisplayString(detail.value?.phone), 1)
                        ]),
                        (_unref(isReadonly))
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createElementVNode("div", _hoisted_35, [
                                _hoisted_36,
                                _createElementVNode("div", _hoisted_37, _toDisplayString(detail.value?.handleResult || ''), 1)
                              ]),
                              _createElementVNode("div", _hoisted_38, [
                                _hoisted_39,
                                (detail.value?.handleResultFeedback)
                                  ? (_openBlock(), _createElementBlock("span", {
                                      key: 0,
                                      class: "value",
                                      style: _normalizeStyle({ color: detail.value?.handleResultFeedback === '1' ? '#F03833' : '#333' })
                                    }, _toDisplayString(detail.value?.handleResultFeedback === '1' ? '有争议' : '无争议'), 5))
                                  : _createCommentVNode("", true)
                              ])
                            ], 64))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]),
                  _: 1
                }, 8, ["visible"])
              ]),
              _createElementVNode("div", _hoisted_40, [
                _hoisted_41,
                _createElementVNode("span", _hoisted_42, _toDisplayString(targetInfo.value.farmerName), 1)
              ]),
              _createElementVNode("div", _hoisted_43, [
                _hoisted_44,
                _createElementVNode("span", _hoisted_45, _toDisplayString(targetInfo.value.caseNo), 1)
              ]),
              _createElementVNode("div", _hoisted_46, [
                _hoisted_47,
                _createElementVNode("span", _hoisted_48, _toDisplayString(targetInfo.value.targetNo), 1)
              ]),
              _createElementVNode("div", _hoisted_49, [
                _hoisted_50,
                _createElementVNode("span", _hoisted_51, _toDisplayString(targetInfo.value.earNo || targetInfo.value.collarBarcode || '-'), 1)
              ]),
              _createElementVNode("div", _hoisted_52, [
                _hoisted_53,
                _createElementVNode("span", _hoisted_54, _toDisplayString(targetInfo.value.livestockAge || '-'), 1)
              ]),
              _createElementVNode("div", _hoisted_55, [
                _hoisted_56,
                _createElementVNode("span", _hoisted_57, _toDisplayString(targetInfo.value.collectAddr), 1)
              ]),
              _createElementVNode("div", _hoisted_58, [
                _hoisted_59,
                _createElementVNode("span", _hoisted_60, [
                  _createTextVNode(" 经度 " + _toDisplayString(targetInfo.value.collectLocation.split(',')[0]), 1),
                  _hoisted_61,
                  _createTextVNode(" 纬度 " + _toDisplayString(targetInfo.value.collectLocation.split(',')[1]), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_62, [
                _hoisted_63,
                _createElementVNode("span", _hoisted_64, _toDisplayString(targetInfo.value.created), 1)
              ]),
              _createElementVNode("div", _hoisted_65, [
                _hoisted_66,
                _createElementVNode("div", _hoisted_67, [
                  _createElementVNode("div", _hoisted_68, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(availableTypes), (type) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "button-container",
                        key: type.value
                      }, [
                        _createVNode(_component_el_button, {
                          class: _normalizeClass(['info-button', { active: activeType.value === type.value }]),
                          onClick: ($event: any) => (switchType(type.value))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(type.label), 1)
                          ]),
                          _: 2
                        }, 1032, ["class", "onClick"])
                      ]))
                    }), 128))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_69, [
                _createElementVNode("div", _hoisted_70, [
                  _createElementVNode("div", _hoisted_71, [
                    _createElementVNode("div", _hoisted_72, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["compare-group", { active: activeCompareType.value === 'insurance' }]),
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (switchCompareType('insurance')))
                      }, [
                        _withDirectives(_createElementVNode("div", _hoisted_73, null, 512), [
                          [_vShow, activeCompareType.value === 'insurance']
                        ]),
                        _hoisted_74,
                        _createVNode(_component_el_select, {
                          ref_key: "selectRef",
                          ref: selectRef,
                          modelValue: compareResult.value,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((compareResult).value = $event)),
                          placeholder: "请选择",
                          class: "result-select",
                          disabled: _unref(isReadonly) || activeCompareType.value === 'claim'
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_option, {
                              label: "投保标的",
                              value: "REPEAT",
                              disabled: _unref(isInsuranceDisabled)
                            }, null, 8, ["disabled"]),
                            _createVNode(_component_el_option, {
                              label: "非投保标的",
                              value: "NORMAL"
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue", "disabled"])
                      ], 2),
                      _createElementVNode("div", {
                        class: _normalizeClass(["compare-group", { active: activeCompareType.value === 'claim' }]),
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (switchCompareType('claim')))
                      }, [
                        _withDirectives(_createElementVNode("div", _hoisted_75, null, 512), [
                          [_vShow, activeCompareType.value === 'claim']
                        ]),
                        _hoisted_76,
                        _createVNode(_component_el_select, {
                          ref_key: "selectRef2",
                          ref: selectRef2,
                          modelValue: claimResult.value,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((claimResult).value = $event)),
                          placeholder: "请选择",
                          class: "result-select",
                          disabled: _unref(isReadonly) || activeCompareType.value === 'insurance'
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_option, {
                              label: "重复理赔标的",
                              value: "REPEAT",
                              disabled: _unref(isClaimDisabled)
                            }, null, 8, ["disabled"]),
                            _createVNode(_component_el_option, {
                              label: "唯一理赔标的",
                              value: "NORMAL"
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue", "disabled"]),
                        (reportStatus.value === '1')
                          ? (_openBlock(), _createBlock(_component_el_button, {
                              key: 0,
                              type: "primary",
                              onClick: _withModifiers(handleComplete, ["stop"]),
                              loading: processing.value,
                              class: "handle-btn"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" 完成处理 ")
                              ]),
                              _: 1
                            }, 8, ["onClick", "loading"]))
                          : _createCommentVNode("", true),
                        (reportStatus.value === '2' && _unref(route).query.status !== '0')
                          ? (_openBlock(), _createBlock(_component_el_button, {
                              key: 1,
                              type: "primary",
                              onClick: _withModifiers(handleReprocess, ["stop"]),
                              class: "handle-btn"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" 重新处理 ")
                              ]),
                              _: 1
                            }, 8, ["onClick"]))
                          : _createCommentVNode("", true)
                      ], 2)
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_77, [
            _createElementVNode("div", _hoisted_78, [
              _createVNode(_component_el_button, {
                class: "nav-button prev",
                onClick: previousImage,
                disabled: !_unref(canGoPrevious)
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(ArrowLeft))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["disabled"]),
              _createVNode(_component_el_button, {
                class: "nav-button next",
                onClick: nextImage,
                disabled: !_unref(canGoNext)
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(ArrowRight))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["disabled"]),
              _createElementVNode("div", _hoisted_79, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(displayImages), (image, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: 'pin-' + image.id,
                    class: "pin-container",
                    style: _normalizeStyle({ gridArea: `${Math.floor(index / 4) + 1} / ${index % 4 + 1}` }),
                    onClick: ($event: any) => (toggleFix(image))
                  }, [
                    _createElementVNode("div", _hoisted_81, [
                      _createElementVNode("i", {
                        class: _normalizeClass(image.fixed ? 'fixed-icon-class' : 'pin-icon-class')
                      }, null, 2)
                    ])
                  ], 12, _hoisted_80))
                }), 128)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(displayImages), (image, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: image.id,
                    class: "image-wrapper",
                    style: _normalizeStyle({ gridArea: `${Math.floor(index / 4) + 1} / ${index % 4 + 1}` })
                  }, [
                    (image.type === 'VIDEO')
                      ? (_openBlock(), _createElementBlock("video", _hoisted_82, [
                          _createElementVNode("source", {
                            src: image.url,
                            type: "video/mp4"
                          }, null, 8, _hoisted_83),
                          _createTextVNode(" Your browser does not support the video tag. ")
                        ]))
                      : (_openBlock(), _createBlock(incImgSvg, {
                          key: 1,
                          class: "image-zoom-container",
                          "dialog-visible": false,
                          "img-width": "100%",
                          "img-src": image.url
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("img", {
                              src: image.url,
                              alt: 'Image ' + image.id
                            }, null, 8, _hoisted_84)
                          ]),
                          _: 2
                        }, 1032, ["img-src"]))
                  ], 4))
                }), 128))
              ])
            ])
          ])
        ])
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_85, [
        _createElementVNode("div", _hoisted_86, [
          (!_unref(isReadonly))
            ? (_openBlock(), _createElementBlock("div", _hoisted_87, [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(onlyShowCompare.value ? 'ShoppingCartFull' : 'ShoppingCart')))
                  ]),
                  _: 1
                }),
                _createElementVNode("span", _hoisted_88, [
                  _createTextVNode(" 对比项："),
                  _createElementVNode("span", {
                    class: _normalizeClass({ 'blue-text': _unref(compareCount) > 0 })
                  }, _toDisplayString(_unref(compareCount)) + "头", 3)
                ]),
                _createVNode(_component_el_icon, {
                  class: "clear-icon",
                  onClick: handleClearAllCompare
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(CloseBold))
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_checkbox, {
                  modelValue: onlyShowCompare.value,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((onlyShowCompare).value = $event))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("只看对比项")
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_89, [
          _createVNode(_component_el_button, {
            class: "nav-button prev",
            onClick: previousCompareItems,
            disabled: !_unref(canGoPreviousCompare)
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_unref(ArrowLeft))
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["disabled"]),
          _createElementVNode("div", _hoisted_90, [
            _createVNode(_component_el_row, {
              type: "flex",
              style: {"width":"100%"}
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(displayCompareItems), (item, index) => {
                  return (_openBlock(), _createBlock(_component_el_col, {
                    key: item.id
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        class: _normalizeClass(getCompareItemClass(item)),
                        onClick: ($event: any) => (handleItemClick(item, index))
                      }, _toDisplayString(getDisplayIndex(item, index)) + " (" + _toDisplayString((item.sim * 100).toFixed(0)) + "%) ", 11, _hoisted_91)
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _createVNode(_component_el_button, {
            class: "nav-button next",
            onClick: nextCompareItems,
            disabled: !_unref(canGoNextCompare)
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_unref(ArrowRight))
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["disabled"]),
          (!_unref(isReadonly))
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                class: "add-compare-btn",
                onClick: handleCompareToggle
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(isItemSelected) ? '取消对比' : '加入对比'), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ], 512), [
        [_vShow, (activeCompareType.value === 'insurance' && compareResult.value === 'REPEAT') ||
            (activeCompareType.value === 'claim' && claimResult.value === 'REPEAT')]
      ]),
      (_unref(showWarningMessage) && activeCompareType.value !== 'claim')
        ? (_openBlock(), _createElementBlock("div", _hoisted_92, " 根据系统对比结果，当前保单有投保验标数据，但当前标的没有找到对应的投保标的，请注意核实。 "))
        : _createCommentVNode("", true),
      _withDirectives(_createElementVNode("div", _hoisted_93, [
        _createElementVNode("div", _hoisted_94, [
          _createElementVNode("div", _hoisted_95, [
            _createElementVNode("div", _hoisted_96, [
              _createElementVNode("div", _hoisted_97, [
                _createElementVNode("span", null, _toDisplayString(activeCompareType.value === 'insurance' ? '投保-对比标的' : '理赔-对比标的'), 1),
                ((!_unref(isReadonly) || _unref(route).query.status !== '0') && _unref(getConfirmButtonStatus))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_98, "（已失效）"))
                  : _createCommentVNode("", true),
                _withDirectives(_createVNode(_component_el_button, {
                  type: "danger",
                  plain: "",
                  disabled: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("已理赔")
                  ]),
                  _: 1
                }, 512), [
                  [_vShow, activeCompareType.value === 'insurance' && !_unref(route).query.status && !_unref(isReadonly) && _unref(getClaimFlag)]
                ]),
                (!(_unref(isReadonly) && _unref(route).query.status === '0') && !_unref(getConfirmButtonStatus) && !_unref(getClaimFlag))
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 1,
                      disabled: _unref(isReadonly),
                      class: "confirm-target-btn",
                      onClick: handleConfirmTarget
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(getConfirmButtonText)), 1)
                      ]),
                      _: 1
                    }, 8, ["disabled"]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_99, [
                _hoisted_100,
                _createElementVNode("span", _hoisted_101, _toDisplayString(_unref(simImages)[currentCompareIndex.value]?.farmerName), 1)
              ]),
              (activeCompareType.value === 'insurance')
                ? (_openBlock(), _createElementBlock("div", _hoisted_102, [
                    _hoisted_103,
                    _createElementVNode("span", _hoisted_104, _toDisplayString(_unref(simImages)[currentCompareIndex.value]?.orderNo), 1)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_105, [
                    _hoisted_106,
                    _createElementVNode("span", _hoisted_107, _toDisplayString(_unref(simImages)[currentCompareIndex.value]?.caseNo), 1)
                  ])),
              _createElementVNode("div", _hoisted_108, [
                _hoisted_109,
                _createElementVNode("span", _hoisted_110, _toDisplayString(_unref(simImages)[currentCompareIndex.value]?.targetNo), 1)
              ]),
              _createElementVNode("div", _hoisted_111, [
                _hoisted_112,
                _createElementVNode("span", _hoisted_113, _toDisplayString(_unref(simImages)[currentCompareIndex.value]?.earNo), 1)
              ]),
              _createElementVNode("div", _hoisted_114, [
                _hoisted_115,
                _createElementVNode("span", _hoisted_116, _toDisplayString(_unref(simImages)[currentCompareIndex.value]?.livestockAge), 1)
              ]),
              _createElementVNode("div", _hoisted_117, [
                _hoisted_118,
                _createElementVNode("span", _hoisted_119, _toDisplayString(_unref(simImages)[currentCompareIndex.value]?.location), 1)
              ]),
              _createElementVNode("div", _hoisted_120, [
                _hoisted_121,
                _createElementVNode("span", _hoisted_122, [
                  _createTextVNode(" 经度 " + _toDisplayString(_unref(simImages)[currentCompareIndex.value]?.longitude), 1),
                  _hoisted_123,
                  _createTextVNode(" 纬度 " + _toDisplayString(_unref(simImages)[currentCompareIndex.value]?.latitude), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_124, [
                _hoisted_125,
                _createElementVNode("span", _hoisted_126, _toDisplayString(_unref(simImages)[currentCompareIndex.value]?.collectDate), 1)
              ]),
              _createElementVNode("div", _hoisted_127, [
                _hoisted_128,
                _createElementVNode("div", _hoisted_129, [
                  _createElementVNode("div", _hoisted_130, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(availableTypesLower), (type) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "button-container",
                        key: type.value
                      }, [
                        _createVNode(_component_el_button, {
                          class: _normalizeClass(['info-button', { active: activeTypeLower.value === type.value }]),
                          onClick: ($event: any) => (switchTypeLower(type.value))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(type.label), 1)
                          ]),
                          _: 2
                        }, 1032, ["class", "onClick"])
                      ]))
                    }), 128))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_131, [
                (!_unref(isReadonly))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_132, [
                      _createElementVNode("div", _hoisted_133, [
                        _createVNode(_component_el_button, {
                          onClick: handleRecompare,
                          style: {"width":"50%","color":"#009DFF","border-color":"#009DFF"}
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" 重新对比 ")
                          ]),
                          _: 1
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_134, [
            _createElementVNode("div", _hoisted_135, [
              _createVNode(_component_el_button, {
                class: "nav-button prev",
                onClick: previousImageLower,
                disabled: !_unref(canGoPreviousLower)
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(ArrowLeft))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["disabled"]),
              _createVNode(_component_el_button, {
                class: "nav-button next",
                onClick: nextImageLower,
                disabled: !_unref(canGoNextLower)
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(ArrowRight))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["disabled"]),
              _createElementVNode("div", _hoisted_136, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(displayImagesLower), (image, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: 'pin-' + image.id,
                    class: "pin-container",
                    style: _normalizeStyle({ gridArea: `${Math.floor(index / 4) + 1} / ${index % 4 + 1}` }),
                    onClick: ($event: any) => (toggleFixLower(image))
                  }, [
                    _createElementVNode("div", _hoisted_138, [
                      _createElementVNode("i", {
                        class: _normalizeClass(image.fixed ? 'fixed-icon-class' : 'pin-icon-class')
                      }, null, 2)
                    ])
                  ], 12, _hoisted_137))
                }), 128)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(displayImagesLower), (image, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: image.id,
                    class: "image-wrapper",
                    style: _normalizeStyle({ gridArea: `${Math.floor(index / 4) + 1} / ${index % 4 + 1}` })
                  }, [
                    (image.type === 'VIDEO')
                      ? (_openBlock(), _createElementBlock("video", _hoisted_139, [
                          _createElementVNode("source", {
                            src: image.url,
                            type: "video/mp4"
                          }, null, 8, _hoisted_140),
                          _createTextVNode(" Your browser does not support the video tag. ")
                        ]))
                      : (_openBlock(), _createBlock(incImgSvg, {
                          key: 1,
                          class: "image-zoom-container",
                          "dialog-visible": false,
                          "img-width": "100%",
                          "img-src": image.url
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("img", {
                              src: image.url,
                              alt: 'Image ' + image.id
                            }, null, 8, _hoisted_141)
                          ]),
                          _: 2
                        }, 1032, ["img-src"]))
                  ], 4))
                }), 128))
              ])
            ])
          ])
        ])
      ], 512), [
        [_vShow, (activeCompareType.value === 'insurance' && compareResult.value === 'REPEAT') ||
            (activeCompareType.value === 'claim' && claimResult.value === 'REPEAT')]
      ])
    ]),
    _createElementVNode("div", null, [
      _createVNode(_component_el_dialog, {
        modelValue: recompareDialogVisible.value,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((recompareDialogVisible).value = $event)),
        title: "标的重新对比",
        width: "600px",
        "close-on-click-modal": false,
        "destroy-on-close": ""
      }, {
        default: _withCtx(() => [
          _createVNode(RecompareDialog, {
            "current-target": targetInfo.value.targetNo,
            "compare-target": _unref(simImages)[currentCompareIndex.value]?.targetNo,
            "current-target-id": _unref(targetIds).currentId,
            "compare-target-id": _unref(targetIds).compareId,
            "available-types": _unref(recompareAvailableTypes),
            "original-similarity": (_unref(simImages)[currentCompareIndex.value]?.sim || 0) * 100,
            "current-active-type": activeType.value,
            "comparison-type": activeCompareType.value,
            "case-id": detail.value?.caseId,
            "order-id": detail.value?.orderId
          }, null, 8, ["current-target", "compare-target", "current-target-id", "compare-target-id", "available-types", "original-similarity", "current-active-type", "comparison-type", "case-id", "order-id"])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_dialog, {
        modelValue: processResultVisible.value,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((processResultVisible).value = $event)),
        title: "理赔验标上报处理",
        width: "1000px",
        "close-on-click-modal": false,
        "show-close": true,
        "destroy-on-close": ""
      }, {
        default: _withCtx(() => [
          _createVNode(ProcessResultDialog, {
            "report-info": processResultDialogProps.value.reportInfo,
            "process-result": processResultDialogProps.value.processResult,
            onConfirm: handleProcessConfirm
          }, null, 8, ["report-info", "process-result"])
        ]),
        _: 1
      }, 8, ["modelValue"])
    ])
  ], 64))
}
}

})